<template>
  <div v-if="visible" class="col-12 text-end">
    <div class="popup_bg" @click="closeModal"></div>
    <div id="switchGraphModal" class="modal_class">
      <div class="modal-content invoice p-4 shadow-lg rounded">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="text-center m-0">Switch Graph - {{ olt }}</h5>
          <span @click="closeModal" class="close">&times;</span>
        </div>
        <div v-if="chartData" class="col-lg-12">
          <!-- line chart -->
          <div class="card z-index-2 invoice-card mt-3" style="height:500px">
            <gradient-graph-chart
              id="chart-line"
              title="Chart"
              description="<i class='fa fa-arrow-up text-success'></i>
      <span class='font-weight-bold'>Chart </span>"
              :chart="chartData"
            />
          </div>
        </div>
        <div v-else class="mt-12">
          <Skalaton />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GradientGraphChart from "@/examples/Charts/GradientGraphChart.vue";
import getSwitchGrapgData from "../services/switch-graph-data.service";
import Skalaton from "@/components/Skalaton.vue";

export default {
  name: "SwitchGraph",
  components: {
    GradientGraphChart,
    Skalaton
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: null
    },
    olt: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      description_data: [],
      dashoard_chart_data: [],
      chartData: null
    }
  },
  watch: {
    visible(newVal) {
      if (newVal && this.id && this.olt) {
        this.getSwitchGrapg();
      } else {
        // Reset chart data when modal closes
        this.chartData = null;
        this.description_data = [];
        this.dashoard_chart_data = [];
      }
    },
    id() {
      if (this.visible && this.id && this.olt) {
        this.getSwitchGrapg();
      }
    },
    olt() {
      if (this.visible && this.id && this.olt) {
        this.getSwitchGrapg();
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    async getSwitchGrapg() {
      if (!this.id || !this.olt) return;
      
      try {
        this.chartData = null; // Reset before loading
        this.dashoard_chart_data = await getSwitchGrapgData.getSwitchGrapgData(this.id, this.olt);
        let data = this.dashoard_chart_data?.data?.filter(item => Object.prototype.hasOwnProperty.call(item, 'RXpowerdBm'));
        this.description_data = data.map(item => {
          const rxPowerValue = item.RXpowerdBm.replace(' dBm', '');
          return Number(rxPowerValue);
        });
        // Prepare chart data
        this.chartData = {
          labels: data?.map(item => `${item.id}`),
          datasets: [
            {
              label: '-dBm',
              data: this.description_data,
            },
          ],
        };
      } catch (error) {
        console.error('Error fetching dashboard chart data:', error);
      }
    },
  }
};

</script>
